/**
 * Opciones de proyecto (vivienda) para autocompletar o seleccionar.
 * @param {Array<Object>} projects Proyectos.
 * @param {Function} [getLabel] Arma la etiqueta de cada proyecto; por defecto, su nombre.
 * @returns {Array<{value: string, label: string}>}
 */
export const toProjectOptions = (projects = [], getLabel = (project) => project.name || '') =>
  projects.map((project) => ({ value: project.uuid, label: getLabel(project) }));
